import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RouteConstants } from '../../../navigation/navigation-types'

export interface SaveStateInputReduxState {
    /**
     * isDialogOpen is true if the unsaved warning dialog is open
     */
    isDialogOpen: boolean
    /**
     * isSaved is false if the user has unsaved changes
     */
    isSaved: boolean
    /**
     * dialogNavigationRoute is the route to navigate to if the user chooses to discard changes
     */
    dialogNavigationRoute: string | -1
}
export interface SaveStateReduxState {
    isDialogOpen: boolean
    isSaved: boolean
    dialogNavigationRoute: string | -1
}

const initialState: SaveStateReduxState = {
    isDialogOpen: false,
    isSaved: true,
    dialogNavigationRoute: RouteConstants.home,
}

export const saveStateSlice = createSlice({
    name: 'saveState',
    initialState,
    reducers: {
        /**
         * setDialogOpen sets the dialog open state if the user has unsaved changes. Function takes a route to navigate to if the user chooses to discard changes
         */
        openDialog: (state, action: PayloadAction<string | -1>) => {
            state.isDialogOpen = !state.isSaved
            state.dialogNavigationRoute = action.payload
        },
        closeDialog: (state) => {
            state.isDialogOpen = false
        },
        setSaveState: (state, action: PayloadAction<boolean>) => {
            state.isSaved = action.payload
        },
    },
})
